import BookingsBg from "./bg/bookings";
import BookingsDa from "./da/bookings";
import BookingsDe from "./de/bookings";
import BookingsEn from "./en/bookings";
import BookingsEs from "./es/bookings";
import BookingsFi from "./fi/bookings";
import BookingsFr from "./fr/bookings";
import BookingsHr from "./hr/bookings";
import BookingsHu from "./hu/bookings";
import BookingsIt from "./it/bookings";
import BookingsLt from "./lt/bookings";
import BookingsLv from "./lv/bookings";
import BookingsMe from "./me/bookings";
import BookingsMk from "./mk/bookings";
import BookingsNl from "./nl/bookings";
import BookingsPl from "./pl/bookings";
import BookingsRs from "./rs/bookings";
import BookingsSe from "./se/bookings";
import BookingsTr from "./tr/bookings";
import BookingsUs from "./en-us/bookings";

export default {
  messages: {
    bg:{bookings:BookingsBg},
    da:{bookings:BookingsDa},
    de:{bookings:BookingsDe},
    en:{bookings:BookingsEn},
    'en-us':{bookings:BookingsUs},
    es:{bookings:BookingsEs},
    fi:{bookings:BookingsFi},
    fr:{bookings:BookingsFr},
    hr:{bookings:BookingsHr},
    hu:{bookings:BookingsHu},
    it:{bookings:BookingsIt},
    lt:{bookings:BookingsLt},
    lv:{bookings:BookingsLv},
    me:{bookings:BookingsMe},
    mk:{bookings:BookingsMk},
    mx:{bookings:BookingsEs},
    nl:{bookings:BookingsNl},
    pl:{bookings:BookingsPl},
    rs:{bookings:BookingsRs},
    se:{bookings:BookingsSe},
    tr:{bookings:BookingsTr},
  },
}
